import React, {Dispatch, SetStateAction} from "react"
import Button from "../../../components/Button/Button"
import {RiskSettingsType} from "../../../components/RiskSettings/RiskSettingsUtils"
import RiskSettingsViewMode from "../../../components/RiskSettings/RiskSettingsViewMode"
import classNames from "classnames"

interface BankRiskSettingsViewModeProps {
	values: RiskSettingsType
	setEditMode: Dispatch<SetStateAction<boolean>>
	canEdit: boolean
	title?: string
}

export default function BankRiskSettingsViewMode({values, setEditMode, canEdit, title}: BankRiskSettingsViewModeProps) {
	const setEditModeToTrue = () => setEditMode(true)
	return (
		<div className="bank-risk-settings-view-mode">
			<div className={classNames("mb-5 is-flex", title ? "is-justify-content-space-between" : "justify-content-end")}>
				{title && <h1 className="has-text-weight-bold is-size-4 is-align-self-center">{title}</h1>}
				{canEdit && (
					<Button
						type="button"
						className="edit-button pr-6 pl-6"
						theme="neutral"
						variant="outline"
						prefixIcon="pencil-1--interface-essential"
						onClick={setEditModeToTrue}
					>
						<span>Edit</span>
					</Button>
				)}
			</div>
			<RiskSettingsViewMode value={values} />
		</div>
	)
}
